<cap-content-header>
  <cap-title>
    {{ "gefundeneGrundbuchgeschaefte" | translate }}
  </cap-title>
  @if (grundbuchgeschaeftListLoader) {
    <cap-title-functionbar>
      <cap-functionbar-searchresult-buttons
        [listLoader]="grundbuchgeschaeftListLoader"></cap-functionbar-searchresult-buttons>
    </cap-title-functionbar>
  }
</cap-content-header>

<ng-container class="cap-table-wrapper-content">
  <cap-list-loader [listLoader]="grundbuchgeschaeftListLoader">
    <div class="cap-list-loader-content">
      <table class="cap-table-search">
        <thead>
        <ng-template [ngTemplateOutlet]="gbgTableHeaders"></ng-template>
        </thead>
        <tbody>
        <ng-template [ngTemplateOutlet]="gbgTableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </cap-list-loader>
</ng-container>

<ng-template #gbgTableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'Tagebuchnummer'"
                         [sortModel]="tableSortModel.columns.get('timePoint')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Eingangsdatum'"
                         [sortModel]="tableSortModel.columns.get('eingangTagebuch')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Geschäftsstatus'"
                         [sortModel]="tableSortModel.columns.get('status')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Anmelder'"
                         [sortModel]="tableSortModel.columns.get('anmelder')"></cap-column-header>
    </th>
    <th>{{ "Beschreibung" | translate }}</th>
    @if (appformatConfigService.settingsConfig$ | async; as settingsConfig) {
      @if (settingsConfig.isDokuLinkGeschaeftConfigured || settingsConfig.isCmisConfigured) {
        <th>{{ "Dokumente" | translate }}</th>
      }
    }
  </tr>
</ng-template>

<ng-template #gbgTableRows>
  @for (gbgeschaeft of grundbuchgeschaeftListLoader?.items; track gbgeschaeft) {
    <tr>
      <td>
        <span>
          <cap-link [params]="[gbgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
            <cap-kompakt-grundbuchgeschaeft [dokulink]="false" [item]="gbgeschaeft"
                                            container="body"> </cap-kompakt-grundbuchgeschaeft>
          </cap-link>
        </span>
      </td>
      <td>
        <span>
          <cap-link [params]="[gbgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
            {{ gbgeschaeft.eingangTagebuch | datum }}
          </cap-link>
        </span>
      </td>
      <td>
        <span>
          <cap-link [params]="[gbgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
            {{ gbgeschaeft.status | translate }}
          </cap-link>
        </span>
      </td>
      <td>
        @if (gbgeschaeft.anmelder) {
          <span class="grundbuchgeschaeft-list__anmelder-link-wrapper">
            @for (entry of gbgeschaeft.anmelder; track entry) {
              <cap-link
                [params]="[entry.masterId.id, entry.version.id.id]"
                [target]="navTargets.NAV_PERSON_STAMM"
                [tooltipParams]="entry | tooltipPersonstammPipe"
                class="grundbuchgeschaeft-list__anmelder-link">
                <cap-kompakt-stammperson [auskunftsperre]="entry.auskunftsperre"
                                         [item]="entry.version"> </cap-kompakt-stammperson>
              </cap-link>
            }
          </span>
        } @else {
          {{ "GemaessGrundbuch" | translate }}
        }
      </td>
      <td>
        @if (gbgeschaeft.beschreibung) {
          <span>
            <cap-link [params]="[gbgeschaeft.id.id]" [target]="navTargets.NAV_GRUNDBUCHGESCHAEFT">
              {{ gbgeschaeft.beschreibung }}
            </cap-link>
          </span>
        } @else {
          {{ "GemaessGrundbuch" | translate }}
        }
      </td>
      @if (appformatConfigService.settingsConfig$ | async; as settingsConfig) {
        @if (settingsConfig.isCmisConfigured && gbgeschaeft.id) {
          <td>
            <cap-cmis
              [target]="{ itemType: 'Geschaeft', id: gbgeschaeft.timePoint?.id.id, tooltipParam: gbgeschaeft.timePoint | formatTimepoint }"></cap-cmis>
          </td>
        } @else if (settingsConfig.isDokuLinkGeschaeftConfigured) {
          <td>
            <cap-dokulink
              [item]="dokuLinkBuilderFactory.create('GBGESCHAEFT').setEntry(gbgeschaeft).build()"></cap-dokulink>
          </td>
        }
      }
    </tr>
  }
</ng-template>

<ng-template #loading>
  <cap-spinner-small></cap-spinner-small>
</ng-template>
